export const GET_STATICS = "GET_STATICS"
export const GET_DATA_TABLE = "GET_DATA_TABLE"
export const UPDATE_STATICS = "UPDATE_STATICS"
export const GET_HEADER_STATICS = "GET_HEADER_STATICS"
export const EMPTY_TABLE = "EMPTY_TABLE"
export const UPDATE_LOADING = "UPDATE_LOADING"